module.exports = __webpack_public_path__ + "img/hamburger-icon.2e40862c.png";